/* ============================================================
   APLEA — runtime partagé
   Trois comportements seulement, aucun framework.
   ============================================================ */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Apparition au scroll ---------- */
  function initReveal(root) {
    var targets = (root || document).querySelectorAll('.aplea-reveal:not(.is-in)');
    if (!targets.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    targets.forEach(function (el) { io.observe(el); });
  }

  document.addEventListener('DOMContentLoaded', function () { initReveal(); });
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); });
  if (document.readyState !== 'loading') initReveal();

  /* ---------- 2. Carrousel horizontal à scroll-snap ---------- */
  if (!customElements.get('aplea-rail')) {
    customElements.define('aplea-rail', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-rail-track]');
        if (!this.track) return;
        this.prev = this.querySelector('[data-rail-prev]');
        this.next = this.querySelector('[data-rail-next]');
        this.onPrev = () => this.scrollBy(-1);
        this.onNext = () => this.scrollBy(1);
        if (this.prev) this.prev.addEventListener('click', this.onPrev);
        if (this.next) this.next.addEventListener('click', this.onNext);
        this.onScroll = () => this.sync();
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.sync();
        this.ro = new ResizeObserver(() => this.sync());
        this.ro.observe(this.track);
      }
      disconnectedCallback() {
        if (this.ro) this.ro.disconnect();
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      }
      step() {
        var item = this.track.firstElementChild;
        if (!item) return this.track.clientWidth;
        var gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return item.getBoundingClientRect().width + gap;
      }
      scrollBy(dir) {
        this.track.scrollBy({ left: dir * this.step(), behavior: reduced ? 'auto' : 'smooth' });
      }
      sync() {
        var t = this.track;
        var max = t.scrollWidth - t.clientWidth - 2;
        if (this.prev) this.prev.disabled = t.scrollLeft <= 2;
        if (this.next) this.next.disabled = t.scrollLeft >= max;
        var hide = max <= 0;
        this.classList.toggle('is-static', hide);
      }
    });
  }

  /* ---------- 3. Onglets chronologiques ---------- */
  if (!customElements.get('aplea-tabs')) {
    customElements.define('aplea-tabs', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        if (!this.tabs.length) return;
        this.onClick = (e) => this.select(this.tabs.indexOf(e.currentTarget));
        this.onKey = (e) => {
          var i = this.tabs.indexOf(document.activeElement);
          if (i < 0) return;
          var n = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = (i + 1) % this.tabs.length;
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = (i - 1 + this.tabs.length) % this.tabs.length;
          if (e.key === 'Home') n = 0;
          if (e.key === 'End') n = this.tabs.length - 1;
          if (n === null) return;
          e.preventDefault();
          this.select(n);
          this.tabs[n].focus();
        };
        this.tabs.forEach((t) => t.addEventListener('click', this.onClick));
        this.addEventListener('keydown', this.onKey);
        this.select(0);
      }
      select(i) {
        this.tabs.forEach((t, k) => {
          var on = k === i;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.setAttribute('tabindex', on ? '0' : '-1');
          t.classList.toggle('is-active', on);
        });
        this.panels.forEach((p, k) => { p.hidden = k !== i; });
      }
    });
  }
})();
